module.exports = __webpack_public_path__ + "img/chest.10ec1aea.jpg";